"use client";

import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import PopUpModal from "../common/PopUpModal";
import { SuccessfulPage } from "../common/SuccessfulPage";
import { useRouter } from "next/navigation";
import LoaderIcon from "../common/LoaderIcon";

const Label = ({ title }) => (
  <p className="f-w-400 font-nunito-sans p-16 color-black form-label" style={{ marginBottom: "5px" }}>
    {title}
    <span style={{ color: "red" }}> *</span>
  </p>
);

const LoginForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);

  const router = useRouter();

  const initialValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleOnSubmit = async (values, { resetForm }) => {
    console.log("Form submitted: ", values);
    try {
      setLoading(true);
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
        credentials: "include",
      });

      let apiResponse;
      try {
        apiResponse = await response.json();
      } catch (jsonError) {
        throw new Error("Invalid JSON response from server");
      }

      console.log("Response from API:", apiResponse);

      if (response.ok) {
        router.push("/admin/jobs");
      } else {
        console.log(`Error: ${apiResponse.error || "Something went wrong"}`);
        setModalData({
          title: "Login Failed!",
          message: apiResponse.error || "Something went wrong",
          status: "error",
        });
        setShowModal(true);
      }
    } catch (errors) {
      console.error("Unexpected error:", errors);
      setModalData({
        title: "Sorry :(",
        message: "An unexpected error occurred. Please try again later.",
        status: "error",
      });
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleOnSubmit}>
        {({ errors, touched }) => (
          <div className="admin-form">
            <Form className="">
              <div className="title t-a-c">
                <h5 className="color-blue f-w-700 font-barlow">Login</h5>
              </div>
              <div className="flex form-data">
                <div>
                  <Label title="Username:" />
                  <Field
                    name="username"
                    type="text"
                    placeholder="Enter username"
                    className={`field-box ${errors.username && touched.username ? "error" : ""}`}
                  />
                  {errors.username && touched.username && (
                    <div className="error-message" style={{ color: "red" }}>
                      {/* {errors.username} */}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex form-data">
                <div>
                  <Label title="Password:" />
                  <Field
                    name="password"
                    type="password"
                    placeholder="Enter password"
                    className={`field-box ${errors.password && touched.password ? "error" : ""}`}
                  />
                  {errors.password && touched.password && (
                    <div className="error-message" style={{ color: "red" }}>
                      {/* {errors.password} */}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex btn form-data">
                <button type="submit" className="btn-submit" disabled={loading}>
                  <div className="flex center-center" style={{ gap: "5px" }}>
                    {loading && <LoaderIcon style={{ width: "16px", height: "16px" }} />}
                    <p>Login</p>
                  </div>
                </button>
              </div>
            </Form>
          </div>
        )}
      </Formik>

      {showModal && (
        <PopUpModal onClose={() => setShowModal(false)}>
          <SuccessfulPage modalData={modalData} onClose={() => setShowModal(false)} />
        </PopUpModal>
      )}
    </>
  );
};

export default LoginForm;
